import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { getColors } from "../../themes/theme";
import { ThemeContext } from "../../context/ThemeContext";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";

export const CurrentPhaseItem = ({ id, name, onEdit, disabled }) => {
  const { darkMode } = useContext(ThemeContext);

  const handleClick = () => {
    if (disabled) return; // Prevent click if disabled
    onEdit(id);
  };

  return (
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{
        width: "100%",
        px: { xs: 2, sm: "20px", md: 2, lg: "20px" },
        py: "12px",
        borderRadius: "5px",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: !disabled
          ? darkMode
            ? getColors.thumbnailBorderDark
            : getColors.thumbnailBorderLight
          : darkMode
          ? "#FFFFFF"
          : "#000000",
        background: darkMode
          ? getColors.thumbnnailBgDark
          : getColors.thumbnnailBgLight,
        cursor: !disabled && "pointer",
        "&:hover": !disabled && {
          borderColor: darkMode
            ? getColors.thumbnailTextDark
            : getColors.thumbnailTextLight,
        },
      }}
      onClick={handleClick}
    >
      <Typography
        sx={{
          fontSize: "22px",
          fontWeight: 500,
          color: !disabled
            ? darkMode
              ? getColors.drawerTextDark
              : getColors.thumbnailTextLight
            : darkMode
            ? "#bbbbbb99"
            : "#22222299",
        }}
      >
        {name}
      </Typography>
      <Box
        display={"flex"}
        justifyContent={"flex-end"}
        width="max-content"
        sx={{
          borderRadius: "50%",
          padding: { xs: 2, sm: "20px", md: 2, lg: "20px" },
          color: !disabled ? "#007FFF" : "#A0A0A0",
          bgcolor: !disabled ? "#E9F3FF" : "#F0F0F0",
          alignItems: "center",
          "&:hover": !disabled && {
            color: "blue",
          },
        }}
        onClick={(e) => {
          e.stopPropagation();
          handleClick();
        }}
      >
        <BorderColorOutlinedIcon />
      </Box>
    </Box>
  );
};
